import { useEffect, useState } from "react";
import noti_svg from "./assets/notification.svg";
import { getUserNotificationCount } from "./Header";

export const ProgressHeader = () => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const on = () => setTick((n) => n + 1);
    window.addEventListener("smarttt-user-updated", on);
    return () => window.removeEventListener("smarttt-user-updated", on);
  }, []);
  void tick;
  let user;
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }
  const showBell = getUserNotificationCount(user) > 0;

  return (
    <div className="page-header">
      <h2>Progress</h2>
      {showBell && (
        <button type="button" className="notification-btn" title="Notifications">
          <img src={noti_svg} alt="" />
        </button>
      )}
    </div>
  );
};